// Clase específica para guardado/lectura/duplicado/exportación de workflows
// Compatible con TS 3.8 / Vue 2 (sin optional chaining).
// Depende solo de localStorage y Date.

import { workflowDataType } from "@/components/Workflow/workflowDataType";

export interface workflow_marketplace_item extends workflowDataType {
  description?: string;
}

const STORAGE_KEY = "workflow_marketplace";

export class workflow_storage {
  public static list(): workflow_marketplace_item[] {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  }

  public static save(current: workflowDataType): workflow_marketplace_item {
    if (!current || !current.name) {
      throw new Error("El workflow debe tener nombre para guardarse.");
    }

    const all = workflow_storage.list();
    const idx = workflow_storage.indexOfByName(all, current.name);

    const nowIso = new Date().toISOString();
    const item: workflow_marketplace_item =
      idx >= 0
        ? {
            ...all[idx],
            ...current,
            updatedAt: nowIso,
          }
        : {
            ...current,
            id: workflow_storage.generateId(),
            createdAt: nowIso,
            updatedAt: nowIso,
          };

    if (idx >= 0) {
      all[idx] = item;
    } else {
      all.push(item);
    }

    workflow_storage.persist(all);
    return item;
  }

  public static new(): workflow_marketplace_item {
    var item: workflow_marketplace_item = {
      id: workflow_storage.generateId(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      name: "",
      nodes: [],
      connections: [],
      description: "",
    };
    return item;
  }

  public static duplicate(
    src: workflow_marketplace_item
  ): workflow_marketplace_item {
    if (!src) {
      throw new Error("No hay workflow para duplicar.");
    }
    const all = workflow_storage.list();
    const nowIso = new Date().toISOString();

    const dup: workflow_marketplace_item = {
      ...src,
      id: workflow_storage.generateId(),
      name: src.name + " (Copia)",
      createdAt: nowIso,
      updatedAt: nowIso,
      // Aseguramos copias profundas de arrays básicos:
      nodes: src.nodes
        ? src.nodes.map(function(n) {
            return { ...n };
          })
        : [],
      connections: src.connections
        ? src.connections.map(function(c) {
            return { ...c };
          })
        : [],
    };

    all.push(dup);
    workflow_storage.persist(all);
    return dup;
  }

  public static deleteById(id: string): void {
    const all = workflow_storage.list();
    const filtered = all.filter(function(w) {
      return w.id !== id;
    });
    workflow_storage.persist(filtered);
  }
  public static importFromJson(json: workflow_marketplace_item): void {
    const all = workflow_storage.list();
    const idx = workflow_storage.indexOfByName(all, json.name);
    if (idx >= 0) {
      all[idx] = json;
    } else {
      all.push(json);
    }
    workflow_storage.persist(all);
  }

  public static exportToFile(item: workflow_marketplace_item): void {
    const dataStr = JSON.stringify(item, null, 2);
    const dataBlob = new Blob([dataStr], { type: "application/json" });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = (item.name || "workflow") + ".json";
    link.click();
    URL.revokeObjectURL(url);
  }

  public static byId(id: string): workflow_marketplace_item | null {
    const all = workflow_storage.list();
    for (let i = 0; i < all.length; i++) {
      if (all[i].id === id) return all[i];
    }
    return null;
  }

  // Utils
  private static generateId(): string {
    return (
      Date.now().toString(36) +
      Math.random()
        .toString(36)
        .substr(2)
    );
  }

  private static indexOfByName(
    arr: workflow_marketplace_item[],
    name: string
  ): number {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].name === name) return i;
    }
    return -1;
  }

  private static persist(arr: workflow_marketplace_item[]): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
  }
}
